import React from 'react';
import Form from 'screens/Error/Form';
import Modal from './Modal';
import { ModalContainer } from './ModalContainer';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import { ModalProps } from './ModalProps';
import ModalTitle from './ModalTitle';

interface IModalContentProps extends ModalProps {
  customModal?: boolean;
  formProps?: { formId: string; onSubmit: () => void };
  maxWidth?: number;
  modalFooter?: React.ReactNode;
  title?: string;
  closeOnOutSideClick?: boolean;
  hideCloseButton?: boolean;
}

const ModalFactory: React.FC<IModalContentProps> = ({ children, customModal, formProps, isActive, maxWidth = 475, modalFooter, onClose, title, closeOnOutSideClick = true, hideCloseButton = false, dataCy }) => {
  const modalContent = (
    <>
      {title && (
        <ModalHeader>
          <ModalTitle data-cy="modal-title">{title}</ModalTitle>
        </ModalHeader>
      )}
      <ModalContent>{children}</ModalContent>
      {modalFooter && <ModalFooter columns={1}>{modalFooter}</ModalFooter>}
    </>
  );

  const formModalContent = formProps && (
    <Form formId={formProps.formId} onSubmit={formProps.onSubmit}>
      {modalContent}
    </Form>
  );

  return customModal ? (
    <ModalContainer isActive={isActive} onClose={onClose} closeOnOutSideClick={closeOnOutSideClick}>
      {children}
    </ModalContainer>
  ) : (
    <Modal
      maxWidth={maxWidth}
      isActive={isActive}
      onClose={() => {
        onClose?.();
      }}
      closeOnOutSideClick={closeOnOutSideClick}
      hideCloseButton={hideCloseButton}
      dataCy={dataCy}
    >
      {formProps ? formModalContent : modalContent}
    </Modal>
  );
};

export default ModalFactory;
